// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3TUxJ","label":"Completed_label__FKoX4"};